var simpleFaq = document.querySelectorAll("#simple_faq .collapse, #simple_faq1 .collapse");
for(var index = 0; index < simpleFaq.length; index++){
    simpleFaq[index].addEventListener("show.bs.collapse", function() {
        this.parentNode.classList.add("show");
    });
    simpleFaq[index].addEventListener("hide.bs.collapse", function() {
        this.parentNode.classList.remove("show");
    });
}

//# sourceMappingURL=faq.47cc6b62.js.map
